import { call, put, select, take, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { push } from 'connected-react-router';
import {
  CANCEL_PREFERENCES,
  SAVE_PREFERENCES,
  SHOW_PASSWORD_CONFIRMATION,
  SHOW_SAVE_CHANGES_CONFIRMATION,
  UPDATE_PASSWORD,
  GET_LEARNER_CAN_CHANGE_L2,
  preferencesActions
} from '../reducer/preferences-reducer';
import {
  appActions,
  LOG_LEVEL,
  TRANSACTION_STATE,
  SET_APP_INITIALIZED,
  appSelectors
} from '../../app/reducer/app-reducer';
import { processServerPasswordUpdate } from '../../login/services/password-change-helpers';
import { authActions, authSelectors, LOGIN_STATUS, USER_UPDATE_COMPLETE } from '@rosetta/react-auth/dist/index';
import { fetchLearnerCanChangeL2 } from '../../launchpad/services/ego-api';

function* submitPasswordUpdate(action) {
  try {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.PENDING));
    const authToken = yield select(authSelectors.authToken);
    const user = yield select(authSelectors.userInfo);
    yield call(
      processServerPasswordUpdate,
      user.gui,
      action.payload.newPassword,
      action.payload.existingPassword,
      authToken
    );
    yield put(preferencesActions.setShowPasswordConfirmation(true));
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.SUCCESS));
  } catch (error) {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.FAIL, JSON.parse(error.message).error));
  }
}

function* dismissPasswordConfirmation(action) {
  if (action.payload.showPasswordConfirmation) {
    yield delay(3000);
    yield put(preferencesActions.setShowPasswordConfirmation(false));
  }
}

function* cancelPreferences(action) {
  yield put(push('/launchpad'));
}

function* savePreferences(action) {
  const preferencesInfo = action.payload.preferencesInfo;
  try {
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.PENDING));
    const status = yield select(authSelectors.loginStatus);
    const haveUser = status === LOGIN_STATUS.LOGGED_IN;
    if (haveUser) {
      // update the user
      yield put(authActions.updateUser(preferencesInfo));
      yield take(USER_UPDATE_COMPLETE);
      yield put(preferencesActions.setShowSaveChangesConfirmation(true));
      yield put(appActions.setLastTransactionState(TRANSACTION_STATE.SUCCESS));
      // browser remains on preferences page to mimic LP status quo
    } else {
      throw new Error('user not logged in');
    }
  } catch (ex) {
    let errorMsg = 'error saving user preferences: ' + ex.message;
    yield put(
      appActions.logEvent({
        level: LOG_LEVEL.ERROR,
        message: errorMsg
      })
    );
    return yield put(appActions.setLastTransactionState(TRANSACTION_STATE.FAIL, errorMsg));
  }
}

function* dismissSaveChangesConfirmation(action) {
  if (action.payload.showSaveChangesConfirmation) {
    yield delay(3000);
    yield put(appActions.setLastTransactionState(TRANSACTION_STATE.NO_TRANSACTION));
    yield put(preferencesActions.setShowSaveChangesConfirmation(false));
  }
}

function* getLearnerCanChangeL2() {
  try {
    const isAppInitialized = yield select(appSelectors.isAppInitialized);
    if (!isAppInitialized) {
      yield take(SET_APP_INITIALIZED); // wait until app is initialized
    }
    const userInfo = yield select(authSelectors.userInfo);
    const authToken = yield select(authSelectors.authToken);
    const learnerCanChangeL2 = yield call(fetchLearnerCanChangeL2, userInfo.organization, authToken);
    yield put(preferencesActions.setLearnerCanChangeL2(learnerCanChangeL2.result));
  } catch (ex) {
    let errorMsg = 'error checking l2: ' + ex.message;
    yield put(
      appActions.logEvent({
        level: LOG_LEVEL.ERROR,
        message: errorMsg
      })
    );
  }
}

export function* preferencesSagas() {
  yield takeLatest(UPDATE_PASSWORD, submitPasswordUpdate);
  yield takeLatest(SHOW_PASSWORD_CONFIRMATION, dismissPasswordConfirmation);
  yield takeLatest(CANCEL_PREFERENCES, cancelPreferences);
  yield takeLatest(SAVE_PREFERENCES, savePreferences);
  yield takeLatest(SHOW_SAVE_CHANGES_CONFIRMATION, dismissSaveChangesConfirmation);
  yield takeLatest(GET_LEARNER_CAN_CHANGE_L2, getLearnerCanChangeL2);
}



// WEBPACK FOOTER //
// ./src/modules/preferences/sagas/preferences-sagas.js